import { controls, grouped, calculateTotalPay } from "../controls";



const calculateRecoveryPay = ([recoverypct, total_pay]) => {
  recoverypct = parseFloat(recoverypct);
  let pay = (recoverypct < 70 && recoverypct > 40) ? parseFloat(total_pay * recoverypct / 70).toFixed(2) : recoverypct <= 40 ? parseFloat(total_pay * 0.5).toFixed(2) : total_pay;
  return pay;
}

const apex_societies = {
  label: "Apex Societies",
  pageLabel: "Apex Societies", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "apex_society_code", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Name of PACS" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "apex_society_display", maxlength: 50 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "apex_society_code", maxlength: 10, isRequired: false, isReadOnly: true }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Name of PACS", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "apex_society_display", isRequired: true, maxlength: 50 }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Sanctioned Posts Nos", star: true }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "sanctioned_posts_nos", isRequired: true, maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "" }),
    ...controls.displayText({ tab: "general", label: "Total Staff Nos", star: true }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "total_staff_nos", isRequired: true, maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "" }),
    {
      widths: "col-sm-12",
      tab: "general",
      title: "Apex Pacs Employees",
      subComponents: [
        ...controls.displayText({ tab: "general", label: "Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "name", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "general", label: "Employment Status", star: true }),
        ...controls.select({
          tab: "general", name: "employment_status", width: "col-sm-2", placeHolder: "Employment Status", defaultValue: "",
          options: [{
            label: "Regular",
            value: "regular"
          },
          {
            label: "Contract",
            value: "contract"
          },
          {
            label: "DC Rate",
            value: "dc_rate"
          },
          {
            label: "Part Time",
            value: "part_time"
          },
          {
            label: "Re-employement",
            value: "Re-employement"
          }
          ]
        }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Employee ID / PF NO", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "employee_no", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "general", label: "Board Resolution No", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "board_resolution_no", maxlength: 50 }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.magicDateLabel({ tab: "general", label: "Board Resolution Date", target: "board_resolution_date", star: false }),
        ...controls.magicDate({ tab: "general", name: "board_resolution_date", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Remarks", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "remarks", width: "col-sm-4", maxlength: 200 }),
        ...controls.displayText({ tab: "general", label: "Salary Bank Name", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "salary_bank_name", width: "col-sm-4", maxlength: 100 }),
        ...controls.displayText({ tab: "general", label: "Salary Ac No", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "salary_ac_no", maxlength: 50 }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Salary Ifsc Code", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "salary_ifsc_code", maxlength: 11 }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Designation", star: true }),
        ...controls.select({
          tab: "general", name: "designation", width: "col-sm-2", placeHolder: "Designation", defaultValue: "",
          options: [{
            label: "Clerk",
            value: "clerk"
          },
          {
            label: "Peon",
            value: "peon"
          },
          {
            label: "Parbandhak",
            value: "parbandhak"
          },
          {
            label: "Salesman",
            value: "salesman"
          },
          {
            label: "Chokidar",
            value: "chokidar"
          },
          {
            label: "Clerk cum Salesman",
            value: "Clerk cum Salesman"
          }]
        }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.magicDateLabel({ tab: "general", label: "Date Of Birth", target: "date_of_birth", star: false }),
        ...controls.magicDate({ tab: "general", name: "date_of_birth", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.magicDateLabel({ tab: "general", label: "Date Of Joining", target: "date_of_joining", star: false }),
        ...controls.magicDate({ tab: "general", name: "date_of_joining", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.magicDateLabel({ tab: "general", label: "Date Of Retirement", target: "date_of_retirement", star: false }),
        ...controls.magicDate({ tab: "general", name: "date_of_retirement", dateType: "ontype" }),
        ...controls.displayText({ tab: "general", label: "", parents: [{ "name": "employment_status", "match": "in", "value": ["contract", "dc_rate", "part_time"] }] }),



        ...controls.displayText({ tab: "general", label: "Monthly Gross Salary Drawn As On 31-03-2017", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }], width: "col-sm-4" }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "gross_salary_drawn", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),

        ...controls.magicDateLabel({ tab: "general", label: "Contract Valid Upto", target: "contract_valid_upto", star: false, parents: [{ "name": "employment_status", "match": "in", "value": ["contract", "dc_rate", "part_time"] }] }),
        ...controls.magicDate({ tab: "general", name: "contract_valid_upto", dateType: "ontype", parents: [{ "name": "employment_status", "match": "in", "value": ["contract", "dc_rate", "part_time"] }], isReadOnly: "edit" }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Basic Salary", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({
          tab: "general", placeHolder: "", name: "basic", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }],
        }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "DA", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "da", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "CA(Cash Allowance)", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "ca", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "HRA", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "hra", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "PF by PACS", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "pf", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Conveyance", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "conveyance", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Special/Other Allowance", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({
          tab: "general", placeHolder: "", name: "special_other", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }],
        }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Medical Allowance", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({
          tab: "general", placeHolder: "", name: "medical", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }],
          onRender: [
            {
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.basic', field: 'basic' }, { source: 'pageData.da', field: 'da' },
              { source: 'pageData.ca', field: 'ca' }, { source: 'pageData.hra', field: 'hra' }, { source: 'pageData.pf', field: 'pf' }, { source: 'pageData.conveyance', field: 'conveyance' },
              { source: 'pageData.special_other', field: 'special_other' }, { source: 'pageData.medical', field: 'medical' }], resultVar: 'getTotalPay'
            },
            { f: 'setParentState', inputs: { dest: "pageData.total", source: 'allResults', field: 'getTotalPay' }, resultVar: "total" },
          ]
        }),
        ...controls.displayText({ tab: "general", label: "" }),
        ...controls.displayText({ tab: "general", label: "Total Cost", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }], isReadOnly: true }),
        ...controls.floatOnly({ tab: "general", placeHolder: "", name: "total", maxlength: 18, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }], isReadOnly: true }),
        ...controls.displayText({ tab: "general", label: "", }),

        ...controls.displayText({ tab: "general", label: "Recovery Percentage", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({
          tab: "general", placeHolder: "", name: "recovery_percentage", maxlength: 5, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }],
          onRender: [
            {
              f: 'runFunction', calcType: calculateRecoveryPay, inputs: [{ source: 'pageData.recovery_percentage', field: 'recovery_percentage' }, { source: 'pageData.total', field: 'total' }], resultVar: 'gettp'
            },
            { f: 'setParentState', inputs: { dest: "pageData.pay_as_per_recovery", source: 'allResults', field: 'gettp' }, resultVar: "gettp2" },
          ]
        }),
        ...controls.displayText({ tab: "general", label: "", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.displayText({ tab: "general", label: "Pay As Per Recovery", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),
        ...controls.floatOnly({
          tab: "general", placeHolder: "", name: "pay_as_per_recovery", maxlength: 18, isReadOnly: true, parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }]
        }),
        ...controls.displayText({ tab: "general", label: "", parents: [{ "name": "employment_status", "match": "in", "value": ["regular"] }] }),



        ...controls.displayText({ tab: "general", label: "Fix Pay", star: false, parents: [{ "name": "employment_status", "match": "in", "value": ["contract", "dc_rate", "part_time", "Re-employement"] }] }),
        ...controls.text({
          tab: "general", placeHolder: "", name: "fix_pay", maxlength: 50,
          parents: [{ "name": "employment_status", "match": "in", "value": ["contract", "dc_rate", "part_time", "Re-employement"] }]
        }),
        ...controls.checkBox({ tab: "general", label: "Is Gross Salary Drawn Is As Per PACS staff Service Rules 2017", default: false, name: "is_salary_as_per_rules", width: "col-sm-12" }),
        ...controls.checkBox({ tab: "general", label: "Is Against Sanctioned Post", default: false, name: "is_against_sanctioned_post", width: "col-sm-12" }),
        ...controls.displayText({ tab: "apex_pacs_employees", width: "col-sm-12", label: "" }),
        // ...controls.displayText({ tab: "apex_pacs_employees", width: "col-sm-4", label: "" }),

        ...controls.button({
          tab: "apex_pacs_employees",
          label: "SAMPLE",
          style: { padding: 0 },
          icon: "excel",
          onclick: {
            action: "downloadSample",
            tableNameField: "apex_pacs_employees",
            requiredField: ["name", "employment_status", "employee_no", "board_resolution_no", "board_resolution_date", "remarks", "salary_bank_name", "salary_ac_no", "salary_ifsc_code", "designation", "date_of_birth", "date_of_joining", "date_of_retirement", "gross_salary_drawn", "contract_valid_upto", "basic", "da", "ca", "hra", "pf", "conveyance", "special_other", "medical", "total", "recovery_percentage", "pay_as_per_recovery", "is_salary_as_per_rules", "is_against_sanctioned_post"]
          }, width: "col-sm-2"
        }),

        ...controls.FileUpload({

          readFile: { targetTable: 'apex_pacs_employees', type: 'csv', columns: ["name", "employment_status", "employee_no", "board_resolution_no", "board_resolution_date", "remarks", "salary_bank_name", "salary_ac_no", "salary_ifsc_code", "designation", "date_of_birth", "date_of_joining", "date_of_retirement", "gross_salary_drawn", "contract_valid_upto", "basic", "da", "ca", "hra", "pf", "conveyance", "special_other", "medical", "total", "recovery_percentage", "pay_as_per_recovery", "is_salary_as_per_rules", "is_against_sanctioned_post"] },
          label: "Fileupload",
          name: "bulk_file_upload",
          placeholder: {
            type: "text",
            value: "Upload Bulk files"
          },
          tab: "apex_pacs_employees",
          width: "col-sm-8"
        }),

        ...controls.button({
          tab: "apex_pacs_employees",
          label: "ADD",
          style: { padding: 0 },
          Bcolor: "success",
          onclick: {
            action: "appendToHTMLTable",
            tableNameField: "apex_pacs_employees",
            requiredField: ["name", "employment_status", "employee_no", "board_resolution_no", "board_resolution_date", "remarks", "salary_bank_name", "salary_ac_no", "salary_ifsc_code", "designation", "date_of_birth", "date_of_joining", "date_of_retirement", "gross_salary_drawn", "contract_valid_upto", "basic", "da", "ca", "hra", "pf", "conveyance", "special_other", "medical", "total", "recovery_percentage", "pay_as_per_recovery", "is_salary_as_per_rules", "is_against_sanctioned_post",],
            required: [],
          }, width: "col-sm-2"
        }),



        {
          tab: "apex_pacs_employees",
          inputType: "table",
          tableTitle: "",
          deletable: true,
          editable: true,
          tableHeaders: [
            { label: "Sr", type: "autoinc" },
            { label: "Name", field: "name" },
            { label: "Employment Status", field: "employment_status" },
            { label: "Employee ID / PF NO", field: "employee_no" },
            { label: "Board Resolution No", field: "board_resolution_no" },
            { label: "Board Resolution Date", field: "board_resolution_date", displaytype: "date" },
            { label: "Remarks", field: "remarks" },
            { label: "Salary Bank Name", field: "salary_bank_name" },
            { label: "Salary Ac No", field: "salary_ac_no" },
            { label: "Salary Ifsc Code", field: "salary_ifsc_code" },
            { label: "Designation", field: "designation" },
            { label: "Date Of Birth", field: "date_of_birth", displaytype: "date" },
            { label: "Date Of Joining", field: "date_of_joining", displaytype: "date" },
            { label: "Date Of Retirement", field: "date_of_retirement", displaytype: "date" },
            { label: "Monthly Gross Salary Drawn As On 31-03-2017", field: "gross_salary_drawn" },
            { label: "Contract Valid Upto", field: "contract_valid_upto", displaytype: "date" },
            { label: "Basic Salary", field: "basic" },
            { label: "DA", field: "da" },
            { label: "CA", field: "ca" },
            { label: "HRA", field: "hra" },
            { label: "PF", field: "pf" },
            { label: "Conveyance", field: "conveyance" },
            { label: "Special/Other Allowance", field: "special_other" },
            { label: "Medical Allowance", field: "medical" },
            { label: "Total Cost", field: "total" },
            { label: "Recovery Percentage", field: "recovery_percentage" },
            { label: "Pay As Per Recovery", field: "pay_as_per_recovery" },
            { label: "Is Gross Salary Drawn As Per Service Rules 2017", field: "is_salary_as_per_rules", displaytype: "tick" },
            { label: "Is Against Sanctioned Post", field: "is_against_sanctioned_post", displaytype: "tick" },
          ],
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          name: "apex_pacs_employees"
        },
      ]
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Apex Societies",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Apex Society Code", accessor: "apex_society_code", },
      { Header: "Name of PACS", accessor: "apex_society_display", },
      { Header: "Sanctioned Posts Nos", accessor: "sanctioned_posts_nos", },
      { Header: "Total Staff Nos", accessor: "total_staff_nos", },
    ]
  }
};
export default apex_societies;